export default "__VITE_ASSET__cD3NDiZn__"